import { unified } from 'unified';
import rehypeParse from 'rehype-parse';
import rehypeRemark from 'rehype-remark';
import { toMarkdown } from 'mdast-util-to-markdown';
import { gfmToMarkdown } from 'mdast-util-gfm';
import type { Root } from 'mdast';

/**
 * Article HTML → markdown.
 *
 * `content_pieces` carries both columns. The HTML is canonical — it is what the
 * editor saves and where the image round writes its slots — so the markdown has
 * to be regenerated from it rather than the other way round. Before this
 * existed, `markdown` froze at whatever the writer handed in at
 * `cockpit content put`, and every later edit and every placed image was
 * missing from it.
 *
 * `gfmToMarkdown` is what keeps a table in an article from throwing on
 * serialize; `hast-util-to-mdast` happily produces table nodes that the base
 * serializer cannot handle.
 */
export function htmlToMarkdown(html: string): string {
  if (!html.trim()) return '';
  const processor = unified().use(rehypeParse, { fragment: true }).use(rehypeRemark);
  const tree = processor.runSync(processor.parse(html)) as Root;

  return toMarkdown(tree, {
    extensions: [gfmToMarkdown()],
    bullet: '-',
    fences: true,
    rule: '-',
  }).trim();
}
